import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useFormik, FormikProvider, Form } from "formik";
import React, { useState } from "react";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentDate } from "../../../../redux/features/generalSlice";
import { useSnackbar } from "notistack";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import MotionWrapper from "../../../../components/MotionWrapper";
import * as Yup from "yup";

const Days = [
  {
    id: 0,
    name: "Sunday",
  },
  {
    id: 1,
    name: "Monday",
  },
  {
    id: 2,
    name: "Tuesday",
  },
  {
    id: 3,
    name: "Wednesday",
  },
  {
    id: 4,
    name: "Thursday",
  },
  {
    id: 5,
    name: "Friday",
  },
  {
    id: 6,
    name: "Saturday",
  },
];

const OptionsPaymentDate = ({ optionTermId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { loading, paymentDates } = useSelector((state) => state.general);
  const [response, setResponse] = useState(null);

  const schema = Yup.object({
    preferredDays: Yup.array()
      .of(Yup.number().required("Day is required"))
      .min(1, "At least one day must be selected"),
  });
  const formik = useFormik({
    initialValues: {
      courseoptionId: optionTermId || "",
      firstPaymentDate: dayjs().format("YYYY-MM-DD"),
      preferredDays: [],
      courseType: 1,
    },
    validationSchema: schema,
    onSubmit: (values) => {
      dispatch(getPaymentDate(values)).then((res) => {
        if (res.payload.status === "failed") {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
        } else if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          setResponse(res.payload.data);
        }
      });
    },
  });

  return (
    <Box>
      {response ? (
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Stack direction={"column"} spacing={1}>
              <Chip
                variant="contained"
                color="primary"
                size="small"
                icon={
                  <Icon icon="solar:calendar-broken" width="20" height="20" />
                }
                label={`Course Start Date :${response?.courseStartDate}`}
              />
              <Chip
                size="small"
                variant="contained"
                color="primary"
                icon={
                  <Icon icon="solar:calendar-broken" width="20" height="20" />
                }
                label={`Course End Date :${response?.courseEndDate}`}
              />
            </Stack>
          </Box>
          <MotionWrapper directions={"left"} delay={0.5}>
            <TableContainer sx={{ mt: 4.2 }} component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>amount</TableCell>
                    <TableCell align="right">payable Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {response?.sessionDates?.map((row) => (
                    <TableRow
                      key={row.payableDate}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.amount}
                      </TableCell>
                      <TableCell align="right">{row.payableDate}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </MotionWrapper>
        </Box>
      ) : (
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <MotionWrapper directions={"right"} delay={0.5}>
              <Stack direction={"column"} spacing={2}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* <DemoContainer components={["DatePicker", "DatePicker"]}> */}
                  <DatePicker
                    label="First Payment Date"
                    value={dayjs(formik.values.firstPaymentDate)}
                    onChange={(newValue) =>
                      formik.setFieldValue(
                        "firstPaymentDate",
                        dayjs(newValue).format("YYYY-MM-DD")
                      )
                    }
                  />
                  {/* </DemoContainer> */}
                </LocalizationProvider>
                <Autocomplete
                  multiple
                  options={Days}
                  getOptionLabel={(option) => option.name}
                  value={
                    Days.filter((s) =>
                      formik.values.preferredDays?.includes(s.id)
                    ) || []
                  }
                  onChange={(event, newValue) => {
                    const daysIds = newValue.map((day) => day.id);
                    formik.setFieldValue("preferredDays", daysIds);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Days"
                      variant="outlined"
                      error={
                        formik.touched.preferredDays &&
                        Boolean(formik.errors.preferredDays)
                      }
                      helperText={
                        formik.touched.preferredDays &&
                        formik.errors.preferredDays
                      }
                    />
                  )}
                />
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    disabled={loading}
                    sx={{
                      color: "white",
                      background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                      borderRadius: 4,
                    }}
                    size="small"
                    type="submit"
                  >
                    <Icon icon="solar:calendar-broken" width="24" height="24" />
                    {loading ? "Please wait..." : "Check Date"}
                  </Button>
                </Box>
              </Stack>
            </MotionWrapper>
          </Form>
        </FormikProvider>
      )}
    </Box>
  );
};

export default OptionsPaymentDate;
